<template>
    <div class="root">
      <div class="top">
        <span class="log" @click="$router.push({name:'tousujilu'})">投诉记录</span>
      </div>
      <div class="form">
        <div class="input-control">
            <div class="label">iccid/短号</div>
            <input v-model="form.iccid"/>
        </div>
        <div class="input-control">
            <div class="label">联系人</div>
            <input  v-model="form.name"/>
        </div>
        <div class="input-control">
            <div class="label">联系电话</div>
            <input v-model="form.mobile"/>
        </div>
        <div class="input-control">
            <div class="label">问题描述</div>
            <textarea v-model="form.desc" rows="10"></textarea>
        </div>
        <div class="input-control">
            <div class="label">附件</div>
          <van-uploader v-model="fileList" preview-size="1.82rem"
                        :max-count="6" multiple>
            <div class="upload">
              <img src="../assets/images/jia_03.png">
            </div>

            <template #preview-cover="{ file }">
              <div class="preview-cover">{{ file.name }}</div>
            </template>
          </van-uploader>
        </div>
        <div class="submit" @click="handleBindCard" >确认提交</div>
        <div class="openqrcode" @click="showQrcode=true" v-if="customerServiceInfo.customerServiceCode">联系客服专员</div>
        <van-dialog v-model="showQrcode" title="客服微信">
          <div style="padding: .2rem">
            <img :src="customerServiceInfo.customerServiceCode" style="width: 100%;" />
            <div style="font-size: .24rem;text-align: left;">{{customerServiceInfo.customerServiceTime}}</div>
          </div>
        </van-dialog>
      </div>
    </div>
</template>

<script>
    export default {
        name: "bind",
        data() {
            return {
                customerServiceInfo:{},
                form:{},
                fileList:[],
                files:[],
              posting:false,
              showQrcode:false
            };
        },
        methods: {
            handleBindCard(){
              if(this.posting)  return false;
              this.posting = true
                this.$toast.loading('提交中')
                let files = [];
                for (let i in this.fileList){
                    files.push(this.fileList[i].file)
                }
                this.upload('/user/feedback',files,this.form,(res)=>{
                    this.$toast.loading().clear();
                    this.posting = false
                    if(res.code){
                        this.$toast.success(res.msg)
                      this.$router.back()
                    }else{
                        this.$toast(res.msg)
                    }
                })
            },
            getCustomerServiceInfo(){
                this.fetchData('/config/getCustomerServiceInfo',{},(res)=>{
                    if(res.code){
                        this.customerServiceInfo = res.data
                    }
                })
            }
        },
        created() {
            this.getCustomerServiceInfo()
            if(this.$route.query.iccid){
              this.form.iccid = this.$route.query.iccid
            }
        }
    };
</script>
<style lang="scss" scoped>
.root{
  .openqrcode{
    text-align: center;
    font-size: .24rem;
    margin-top: .2rem;
    text-decoration: underline;
    color: #0581ff;
  }
  .submit{
    color: #fff;
    font-size: .32rem;
    background: #ff5d5d;
    width: 2rem;
    height: .6rem;
    line-height: .6rem;
    text-align: center;
    margin: .6rem auto 0;
    border-radius: .4rem;
  }
  .top{
    padding-top: .8rem;
    text-align: right;
    span{
      font-size: .32rem;
      padding-bottom: .08rem;
      border-bottom: 2px solid #808080;
      font-weight: bold;
      letter-spacing: .06rem;
    }
  }
  .form{
    width:5.7rem;
    margin: 0 auto;
    .input-control{
      .label{
        font-size: .28rem;
        text-indent: .1rem;
        line-height: .65rem;
        font-weight: bold;
      }
      .upload{
        width: 1.78rem;
        height: 1.78rem;
        border: 2px dotted #888;
        background: #d3d3d3;
        img{
          display: block;
          width: .68rem;
          height: .68rem;
          margin: .55rem auto;
          vertical-align: middle;
        }
      }
      input{
        color: #000;
        font-size: .26rem;
        text-indent: .1rem;
        display: block;
        width: 100%;
        height: .6rem;
        line-height: .6rem;
        border: none;
        background: #d3d3d3;
      }
      textarea{
        text-indent: .1rem;
        font-size: .26rem;
        color: #000;
        display: block;
        border: none;
        width: 100%;
        background: #d3d3d3;
        height: 2.2rem;
      }
    }
  }
  color: #808080;
  height: inherit;
  font-size: 0;
  background: #fff;
  padding: 0 .4rem;
  overflow-y: scroll;
}

</style>



// WEBPACK FOOTER //
// src/pages/feedback.vue